import { apiCall } from "../../../_services/apiCall";
import config from "../../../config/config.json";

const ADMIN_API_URL = config.ADMIN_API_URL;

/**
 * Every energy source, latest first, with its reference and factor count.
 * Silent, because the page shows its own error.
 */
export const getEnergySources = () => apiCall(`${ADMIN_API_URL}energySources`, {}, {}, "GET", { silent: true });

/**
 * Creates an energy source, or edits source `id`. Silent, because the form
 * shows the outcome.
 *
 * @param {number|null} id
 * @param {ReturnType<typeof import("./helpers").sourceDraftToPayload>} values
 */
export const saveEnergySource = (id, values) =>
  id == null
    ? apiCall(`${ADMIN_API_URL}energySources`, {}, values, "POST", { silent: true })
    : apiCall(`${ADMIN_API_URL}energySources/${id}`, {}, values, "PUT", { silent: true });

/**
 * Silent, because the sources tab shows the outcome.
 *
 * @param {number} id
 */
export const deleteEnergySource = (id) => apiCall(`${ADMIN_API_URL}energySources/${id}`, {}, {}, "DELETE", { silent: true });

/**
 * Every energy factor with its KPI, source, values and references. Silent,
 * because the page shows its own error.
 */
export const getEnergyFactors = () => apiCall(`${ADMIN_API_URL}energyFactors`, {}, {}, "GET", { silent: true });

/** The energy KPIs with the units each accepts, for the factor form. */
export const getEnergyKpis = () => apiCall(`${ADMIN_API_URL}energyKpis`, {}, {}, "GET", { silent: true });

/**
 * Creates an energy factor, or edits factor `id`. Silent, because the form
 * shows the outcome.
 *
 * @param {number|null} id
 * @param {ReturnType<typeof import("./helpers").factorDraftToPayload>} values
 */
export const saveEnergyFactor = (id, values) =>
  id == null
    ? apiCall(`${ADMIN_API_URL}energyFactors`, {}, values, "POST", { silent: true })
    : apiCall(`${ADMIN_API_URL}energyFactors/${id}`, {}, values, "PUT", { silent: true });

/**
 * Silent, because the factors tab shows the outcome.
 *
 * @param {number} id
 */
export const deleteEnergyFactor = (id) => apiCall(`${ADMIN_API_URL}energyFactors/${id}`, {}, {}, "DELETE", { silent: true });

/**
 * Points the density, the calorific value or both of many factors at one
 * reference, or clears them with `reference_id` null.
 *
 * @param {{ reference_id: number|null, targets: ("density"|"calorific")[], factor_ids: number[] }} change
 */
export const applyEnergyFactorReference = (change) =>
  apiCall(`${ADMIN_API_URL}energyFactorReferences`, {}, change, "PUT");
